import React from 'react'
import { Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

import './quantity_input_element.scss'

export const QuantityInputElement = ({
  quantity,
  setQuantity,
  elementName,
  register,
  setValue,
  isDisabled = false
}) => {
  const handleQuantityIncrease = () => {
    // @todo, check product inventory first (cache product inventory request)?
    setQuantity((value) => {
      const increase = parseInt(value) + 1
      setValue(elementName, increase)
      return increase
    })
  }

  const handleQuantityDecrease = () => {
    setQuantity((value) => {
      const decrease = parseInt(value) - 1
      if (decrease > 0) {
        setValue(elementName, decrease)
        return decrease
      }
      else {
        setValue(elementName, 1)
        return 1
      }
    })
  }

  return (
    <div className="quantity-element-container">
      <div className="quantity-element">
        <Stack direction='horizontal' gap={0}>
          <button disabled={isDisabled} type="button" onClick={() => handleQuantityDecrease()}>
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <input min="1" type="number" defaultValue={parseInt(quantity)} {...register} />
          <button disabled={isDisabled} type="button" onClick={() => handleQuantityIncrease()}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </Stack>
      </div>
    </div>
  )
}
